import axios from "axios";
import { initialize } from "../serviceConfig";

let token_sso;

const ensureInitialized = async () => {
    const { api_sso, token_sso: newToken } = await initialize();

    token_sso = newToken;
    return api_sso;
};

const getAxiosApi = (api) => {
  const baseURL = api.base_url;
  let axiosApi = axios.create({ baseURL });

  axiosApi.defaults.headers.common["Content-Type"] = "application/json";
  axiosApi.defaults.headers.common["client_id"] = `${api.client_id}`;
  axiosApi.defaults.headers.common["client_secret"] = `${api.client_secret}`;
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token_sso}`;
  return axiosApi;
};

const authApp = async () => { 
  const api_sso = await ensureInitialized();
  const url = `/auth/authenticate/app`;
  return getAxiosApi(api_sso)
    .post(url, { grantType: "client_credentials" })
    .then((response) => response.data);
};

const authUser = async (loginModel) => {
  const api_sso = await ensureInitialized();
  const url = `/auth/authenticate/user`;
  return getAxiosApi(api_sso)
    .post(url, loginModel)
    .then((response) => response.data);
};

const authUserByCode = async (loginModel) => {
  const api_sso = await ensureInitialized();
  const url = `/auth/authenticate/user`;
  return getAxiosApi(api_sso)
    .post(url, loginModel)
    .then((response) => response.data);
};

export { authApp, authUser, authUserByCode };
